import React, { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { Card, Table, Empty, Divider, Select, Spin } from 'antd';
import dayjs from 'dayjs'
import 'dayjs/locale/ru'
import { Action, CollectionServer, JSXMap, updateInArray, useMetaContext, ycStorage } from 'fennec-ui'
import Filtered from '../Filtered'
import { DropdownAction } from 'fennec-ui'
import { GET, POST, queryFilterByItem, errorCatch } from 'fennec-ui'
import "./index.css"
import { createUseStyles } from 'react-jss';

import NoviePromokodi from '../../forms/NoviePromokodi'
import IzmenitPromokodi from '../../forms/IzmenitPromokodi';
import User from '../../../common/User';
import YImage from '../../../common/YImage';
import { ycBucket } from '../../../common/Tool';


dayjs.locale('ru');
var _ = require('lodash');

const { Option } = Select;

const useStyles = createUseStyles({
    collapse: {
        '& .ant-collapse-content > .ant-collapse-content-box': {
            padding: "0px"
        },
        '&.ant-collapse > .ant-collapse-item > .ant-collapse-header .ant-collapse-arrow': {
            top: "-3px",
            left: "10px"
        },
        '&.ant-collapse > .ant-collapse-item > .ant-collapse-header': {
            padding: "4px 10px",
            paddingLeft: "30px"
        }
    },
    cardSmall: {
        '& .ant-card-body': {
            padding: "0px"
        }
    }
})

function Btn(props) {
    const dispatch = useDispatch();
    const { object, sourceKey, auth, context, queryFilterContext, soruceID, setPromokodi } = props;
    return (
        <>
            <DropdownAction items={[
                {
                    ...props,
                    title: "Изменить",
                    auth: auth,
                    modal: {
                        width: "800px",
                        title: "Изменить промокод",
                    },
                    object: object,
                    mode: "MenuItem",
                    action: (values, unlock, close) => {
                        POST(auth, '/api/promokodi/update', {
                            ...values, ID: (object) ? object.ID : undefined,
                            promouter: { userID: values?.promouter?.ID },
                        },
                            ({ data }) => {
                                setPromokodi(o => updateInArray(o, data))
                                close();
                            },
                            (err) => errorCatch(err, unlock)
                        );
                    },
                    context: context,
                    sourceKey: sourceKey,
                    soruceID: object?.meropriyatieID,
                    form: IzmenitPromokodi,
                    queryFilterContext: queryFilterContext,
                }
            ]} />
        </>
    )
};




export default function StreamLogBlock(props) {
    const { auth, source, create, ctx, sourceKey, title, size, event } = props;
    const meta = useMetaContext();

    const filters = () => [
        {
            "name": "Operation",
            "type": "object",
            "filterType": "",
            "label": "Операция",
            "relation": {
                "type": "many-one",
                "reference": {
                    "object": "LogOperations",
                    "property": "ID"
                },
            },
            display: (o) => o.name,
            "sort": true,
            "filter": true
        },
        // {
        //     "name": "User",
        //     "type": "object",
        //     "filterType": "",
        //     "label": "Пользователь",
        //     "relation": {
        //         "type": "many-one",
        //         "reference": {
        //             "object": "User",
        //             "property": "ID"
        //         },
        //     },
        //     "sort": true,
        //     "filter": true
        // },
        {
            "name": "Message",
            "type": "string",
            "filterType": "",
            "label": "Сообщение",
            "sort": true,
            "filter": true
        },
        {
            "name": "Level",
            "type": "object",
            "filterType": "",
            "label": "Уровень логирования",
            "relation": {
                "uuid": "",
                "type": "many-one",
                "reference": {
                    "object": "LogLevel",
                    "property": "ID"
                },
            },
            display: (o) => o.name,
            "sort": true,
            "filter": true
        },
        // {
        //     "name": "Reklama",
        //     "type": "object",
        //     "filterType": "",
        //     "label": "Реклама",
        //     "relation": {
        //         "uuid": "",
        //         "type": "many-one",
        //         "reference": {
        //             "object": "Reklama",
        //             "property": "ID"
        //         },
        //     },
        //     "sort": true,
        //     "filter": true
        // },
        // {
        //     "name": "Bunch",
        //     "type": "object",
        //     "filterType": "",
        //     "label": "Заход",
        //     "relation": {
        //         "type": "many-one",
        //         "reference": {
        //             "object": "Bunch",
        //             "property": "ID"
        //         },
        //     },
        //     "sort": true,
        //     "filter": true
        // },
        // {
        //     "name": "Tour",
        //     "type": "object",
        //     "filterType": "",
        //     "label": "Тур",
        //     "relation": {
        //         "type": "many-one",
        //         "reference": {
        //             "object": "Tour",
        //             "property": "ID"
        //         },
        //     },
        //     "sort": true,
        //     "filter": true
        // },
        // {
        //     "name": "Kategoriya",
        //     "type": "object",
        //     "filterType": "",
        //     "label": "Категория",
        //     "relation": {
        //         "type": "many-one",
        //         "reference": {
        //             "object": "KategoriiUchastnikovNaMeropriyatiyakh",
        //             "property": "ID"
        //         },
        //     },
        //     display: (o) => o?.tantsevalnayaDistsiplinaPsevdonim + " - " + o?.kategoriyaUchastnikovPsevdonim,
        //     "sort": true,
        //     "filter": true
        // },
        // {
        //     "name": "Meropriyatie",
        //     "type": "object",
        //     "filterType": "",
        //     "label": "Мероприятие",
        //     "relation": {
        //         "type": "many-one",
        //         "reference": {
        //             "object": "Meropriyatiya",
        //             "property": "ID"
        //         },
        //     },
        //     "sort": true,
        //     "filter": true
        // },
        // {
        //     "name": "Subject",
        //     "type": "string",
        //     "filterType": "",
        //     "label": "Тема",
        //     "sort": true,
        //     "filter": true
        // },
        {
            "name": "CreatedAt",
            "type": "datetime",
            "filterType": "range",
            "label": "Время создания",
            "sort": true,
            "filter": true
        },
    ];

    const render = (items, {
        collection,
        setCollection,
        setCollectionItem,
        removeCollectionItem,
        collectionActions,
        modelActions,
        update,
        lastFuncStat,
        lock,
        unlock,
        loading
    }) => {
        return (<div>
            <Spin spinning={loading} tip="Загрузка...">
                {JSXMap(items || [], (item, cidx) => {
                    return (<div key={cidx}>
                        <div className='bg bg-fwhite' style={{ fontSize: "12px", color: "rgba(0,0,0,0.85)", display: "flex" }}>
                            <div style={{ flex: "0 0 50px" }}>
                                <div style={{ fontSize: "11px", color: "rgba(0,0,0,0.65)" }}>{item?.level?.name}</div>
                            </div>
                            <div style={{ flex: "1 1 auto" }}>
                                <div className='bg bg-grey light-3' style={{ display: "flex", justifyContent: "space-between", padding: "5px 10px" }}>
                                    <div>{dayjs(item?.CreatedAt).format("YYYY-MM-DD HH:mm:ss")}</div>
                                    <div><User item={item?.user} noborder={true} /></div>
                                </div>

                                <div style={{ textAlign: "left", padding: "5px 10px 10px 10px" }}>
                                    <div style={{ fontWeight: "bold" }}>{item?.operation?.name}</div>
                                    {item?.kategoriya && <div>{item?.kategoriya?.tantsevalnayaDistsiplinaPsevdonim} - {item?.kategoriya?.kategoriyaUchastnikovPsevdonim}</div>}
                                    {item?.tour && <div>Тур №{item?.tour.number} ({item?.tour?.tourType.name})</div>}
                                    {item?.bunch && <div>Заход {item?.bunch.number}</div>}
                                    {item?.reklama && <div>Реклама: {item?.reklama.opisanie}</div>}
                                    {/* {item?.reklama && <div style={{ padding: "10px 0px", width: "100%", borderTop: "1px solid #eee" }}>
                                                <div style={{ display: "flex", gap: "5px" }}>
                                                    <div style={{ flex: "0 0" }}>
                                                        {item?.reklama?.file?.fileType?.groupe == "image" && <YImage image={item?.reklama?.file?.path} minimage={item?.reklama?.file?.path} width={78} />}
                                                        {item?.reklama?.file?.fileType?.groupe == "video" && <video src={ycStorage(auth) + ycBucket(auth) + "/" + item?.reklama?.file?.path} style={{ width: "78px" }}></video>}
                                                    </div>
                                                    <div style={{ flex: "1 1 auto" }}>
                                                        <div>
                                                            {item?.reklama.opisanie}
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>} */}
                                    <div style={{ fontStyle: "italic" }}>{item?.message}</div>
                                </div>
                            </div>
                        </div>
                    </div>)
                })}
                {/* <div className='scrollable' style={{}}>
                    <table className="xtable" style={{ fontSize: "13px", lineHeight: "normal" }}>
                        <thead>
                            <tr>
                                <th className={`fixed height-8`} style={{ minWidth: "180px", maxWidth: "180px" }}>
                                    <div className='bg bg-grey dark-1' style={{ minWidth: "unset" }}>Промоутер / артист / куратор / владелец школы</div>
                                </th>
                                <th className="fixed height-8" style={{ left: "180px", minWidth: "180px", maxWidth: "180px" }}>
                                    <div className='bg bg-grey dark-1' style={{ minWidth: "unset" }}>Активность / Категория / Промокод</div>
                                </th>
                                <th className="height-8" style={{ minWidth: "120px", maxWidth: "120px", fontWeight: "300" }}>
                                    <div className="bg bg-grey">
                                        Агентское вознаграждение %
                                    </div>
                                </th>
                                <th className="height-8" style={{ minWidth: "120px", maxWidth: "120px", fontWeight: "300" }}>
                                    <div className="bg bg-grey">
                                        Агентское вознаграждение сумма
                                    </div>
                                </th>
                                <th className="height-8" style={{ minWidth: "45px", maxWidth: "45px", fontWeight: "300" }}>
                                    <div className="bg bg-grey">
                                        Активно
                                    </div>
                                </th>
                                <th className="height-8" style={{ minWidth: "100px", maxWidth: "100px", fontWeight: "300" }}>
                                    <div className="bg bg-grey">
                                        Гонорар расчетный
                                    </div>
                                </th>
                                <th className="height-8" style={{ minWidth: "110px", maxWidth: "100px", fontWeight: "300" }}>
                                    <div className="bg bg-grey">
                                        Гонорар к перечислению
                                    </div>
                                </th>
                                <th className="height-8" style={{ minWidth: "110px", maxWidth: "100px", fontWeight: "300" }}>
                                    <div className="bg bg-grey">
                                        Сумма на накопительный
                                    </div>
                                </th>
                                <th className="height-8" style={{ minWidth: "100px", maxWidth: "100px", fontWeight: "300" }}>
                                    <div className="bg bg-grey">
                                        Сумма на текущий
                                    </div>
                                </th>
                            </tr>
                            <tr>
                                <th className={`fixed height-4`} style={{ minWidth: "180px", minWidth: "unset" }}>
                                    <div className='bg bg-grey dark-1' style={{ minWidth: "unset" }}></div>
                                </th>
                                <th className="fixed height-4" style={{ left: "180px", minWidth: "180px", minWidth: "unset" }}>
                                    <div className='bg bg-grey dark-1' style={{ minWidth: "unset" }}></div>
                                </th>
                                <th className="height-4" style={{ minWidth: "120px", fontWeight: "300" }}>
                                    <div className="bg bg-grey">

                                    </div>
                                </th>
                                <th className="height-4" style={{ minWidth: "120px", fontWeight: "300" }}>
                                    <div className="bg bg-green" style={{ fontWeight: "bold" }}>
                                    </div>
                                </th>
                                <th className="height-4" style={{ minWidth: "45px", fontWeight: "300" }}>
                                    <div className="bg bg-grey">

                                    </div>
                                </th>
                                <th className="height-4" style={{ minWidth: "100px", fontWeight: "300" }}>
                                    <div className="bg bg-green" style={{ fontWeight: "bold" }}>
                                    </div>
                                </th>
                                <th className="height-4" style={{ minWidth: "110px", fontWeight: "300" }}>
                                    <div className="bg bg-green" style={{ fontWeight: "bold" }}>
                                    </div>
                                </th>
                                <th className="height-4" style={{ minWidth: "110px", fontWeight: "300" }}>
                                    <div className="bg bg-green" style={{ fontWeight: "bold" }}>
                                    </div>
                                </th>
                                <th className="height-4" style={{ minWidth: "100px", fontWeight: "300" }}>
                                    <div className="bg bg-green" style={{ fontWeight: "bold" }}>
                                    </div>
                                </th>
                            </tr>
                        </thead>
                        <tbody style={{ fontSize: "12px" }}>
                            {JSXMap(items || [], (item, cidx) => {
                                return (<tr key={cidx}>
                                    <td className={`fixed height-5`} style={{ minWidth: "180px" }}>
                                        <div>
                                        </div>
                                    </td>
                                    <td className="fixed height-5" style={{ left: "180px", minWidth: "180px" }}>
                                        {item?.aktivnost && <div className='bg bg-grey light-9' style={{ height: "100%", minWidth: "unset", textAlign: "left", padding: "2px 5px", display: "flex", justifyContent: "left", alignItems: "center", overflow: "hidden" }}>
                                            <div style={{
                                                whiteSpace: "nowrap",
                                                overflow: "hidden",
                                                textOverflow: "ellipsis",
                                            }}>
                                                <div style={{
                                                    color: "rgba(0, 0, 0, 0.45)",
                                                    textAlign: "left",
                                                    textWrap: "nowrap",
                                                    whiteSpace: "nowrap",
                                                    overflow: "hidden",
                                                    textOverflow: "ellipsis",
                                                    fontSize: "12px",
                                                    fontWeight: "lighter"
                                                }}>
                                                    Активность
                                                </div>
                                                <div style={{
                                                    whiteSpace: "nowrap",
                                                    overflow: "hidden",
                                                    textOverflow: "ellipsis",
                                                }}>{item?.aktivnost?.nazvanie}</div>
                                            </div>
                                        </div>}
                                        {item?.kategoriya && <div className='bg bg-grey light-9' style={{ height: "100%", minWidth: "unset", textAlign: "left", padding: "2px 5px", display: "flex", justifyContent: "left", alignItems: "center", overflow: "hidden" }}>
                                            <div style={{
                                                whiteSpace: "nowrap",
                                                overflow: "hidden",
                                                textOverflow: "ellipsis",
                                            }}>
                                                <div style={{
                                                    color: "rgba(0, 0, 0, 0.45)",
                                                    textAlign: "left",
                                                    textWrap: "nowrap",
                                                    whiteSpace: "nowrap",
                                                    overflow: "hidden",
                                                    textOverflow: "ellipsis",
                                                    fontSize: "12px",
                                                    fontWeight: "lighter"
                                                }}>
                                                    Категория
                                                </div>
                                            </div>
                                        </div>}
                                        {item?.promokod && <div className='bg bg-grey light-9' style={{ height: "100%", minWidth: "unset", textAlign: "left", padding: "2px 5px", display: "flex", justifyContent: "left", alignItems: "center", overflow: "hidden" }}>
                                            <div style={{
                                                whiteSpace: "nowrap",
                                                overflow: "hidden",
                                                textOverflow: "ellipsis",
                                            }}>
                                                <div style={{
                                                    color: "rgba(0, 0, 0, 0.45)",
                                                    textAlign: "left",
                                                    textWrap: "nowrap",
                                                    whiteSpace: "nowrap",
                                                    overflow: "hidden",
                                                    textOverflow: "ellipsis",
                                                    fontSize: "12px",
                                                    fontWeight: "lighter"
                                                }}>
                                                    Промокод
                                                </div>
                                                <div style={{
                                                    whiteSpace: "nowrap",
                                                    overflow: "hidden",
                                                    textOverflow: "ellipsis",
                                                }}>{item?.promokod?.promokod}</div>
                                            </div>
                                        </div>}
                                        {(!item?.aktivnost && !item?.kategoriya && !item?.promokod) && <div className='bg bg-grey light-9' style={{ height: "100%", minWidth: "unset", padding: "2px 5px", display: "flex", justifyContent: "left", alignItems: "center", overflow: "hidden" }}>
                                            <div>

                                            </div>
                                        </div>}
                                    </td>
                                    <td className="height-5" style={{ minWidth: "120px" }}>
                                        <div className="bg bg-grey dark-1 border-transparent" style={{ height: "100%", padding: "2px 5px", display: "flex", justifyContent: "center", alignItems: "center" }}>
                                            <div>
                                            </div>
                                        </div>
                                    </td>
                                    <td className="height-5" style={{ minWidth: "120px" }}>
                                        <div className="bg bg-grey dark-1 border-transparent" style={{ height: "100%", padding: "2px 5px", display: "flex", justifyContent: "center", alignItems: "center" }}>
                                            <div>
                                            </div>
                                        </div>
                                    </td>
                                    <td className="height-5" style={{ minWidth: "100px" }}>
                                        <div className="bg bg-grey dark-1 border-transparent" style={{ height: "100%", padding: "2px 5px", display: "flex", justifyContent: "center", alignItems: "center" }}>
                                        </div>
                                    </td>

                                    <td className="height-5" style={{ minWidth: "100px" }}>
                                        <div className="bg bg-orange dark-1 border-transparent" style={{ height: "100%", padding: "2px 5px", display: "flex", justifyContent: "center", alignItems: "center" }}>
                                            <div>
                                            </div>
                                        </div>
                                    </td>
                                    <td className="height-5" style={{ minWidth: "110px" }}>
                                        <div className="bg bg-grey dark-1 border-transparent" style={{ height: "100%", padding: "2px 5px", display: "flex", justifyContent: "center", alignItems: "center" }}>
                                            <div>
                                            </div>
                                        </div>
                                    </td>
                                    <td className="height-5" style={{ minWidth: "110px" }}>
                                        <div className="bg bg-grey dark-1 border-transparent" style={{ height: "100%", padding: "2px 5px", display: "flex", justifyContent: "center", alignItems: "center" }}>
                                            <div>
                                            </div>
                                        </div>
                                    </td>
                                    <td className="height-5" style={{ minWidth: "100px" }}>
                                        <div className="bg bg-grey dark-1 border-transparent" style={{ height: "100%", padding: "2px 5px", display: "flex", justifyContent: "center", alignItems: "center" }}>
                                            <div>
                                            </div>
                                        </div>
                                    </td>
                                </tr>)
                            })}
                        </tbody>
                    </table>
                </div> */}
            </Spin>
        </div>)
    }

    const filtersFromMeta = React.useCallback((name) => {
        let prop = [];
        let p = _.get(meta[name], "properties");
        if (p) {
            prop = p?.filter(e => !_.get(e, "relation") || _.get(e, "relation.type") !== "one-many")?.map(e => ({ ...e, sort: true, filter: true, func: (e.filterType == "range") ? ["min", "max"] : undefined }))
        }
        return prop;
    }, [meta]);

    // console.log(filtersFromMeta("StreamLog"));

    return (
        <>
            <CollectionServer
                auth={auth}
                name={"StreamLog"}
                filters={filters}
                // filters={() => filtersFromMeta("StreamLog")}
                mode="list"
                source={`/api/streamlog/list/meropriyatie/${event.ID}`}
                contextFilters={ctx}
                customRender={render}
            />
        </>
    );
}
